export class ErrorModel {

    [key: string]: string[];

    constructor(source: ErrorModel) {
        Object.keys(source).forEach(x => {
            this[x] = source[x];
        }, this);
    }
}